import { Paper, Skeleton, Group } from "@mantine/core";
import useIsDesktop from "../../../hooks/useIsDesktop";

export default function PaymentInfoSkeleton() {
  const isDesktop = useIsDesktop();

  return (
    <Paper shadow="xs" radius="md" p={{ base: "sm", sm: "xl" }} className="bg-white">
      <div className="mb-10 border-b pb-6">
        <Group justify="space-between" align="center" mb="sm" wrap="wrap" gap="sm">
          <div className="space-y-2">
            <Skeleton height={isDesktop ? 20 : 16} width={180} radius="sm" />
            <Skeleton height={isDesktop ? 14 : 12} width={isDesktop ? 260 : 180} radius="sm" />
          </div>

          <Skeleton height={isDesktop ? 36 : 30} width={isDesktop ? 140 : 110} radius="xl" />
        </Group>
      </div>

      <Skeleton height={isDesktop ? 60 : 48} radius="lg" className="mb-6" />

      <Group gap="md" className="mb-4">
        <Skeleton height={28} width={isDesktop ? 80 : 64} radius="sm" />
        <Skeleton height={28} width={isDesktop ? 80 : 64} radius="sm" />
        <Skeleton height={28} width={isDesktop ? 80 : 64} radius="sm" />
      </Group>

      <div className="space-y-4 mt-4">
        <Skeleton height={50} radius="md" />
        <Skeleton height={50} radius="md" />
        <Skeleton height={50} radius="md" />
      </div>
    </Paper>
  );
}
